import React from 'react';
import { styled } from '@linaria/react';
import { useSplitBookingRoomOfferInteraction } from 'hooks/useSplitBookingOfferInteraction';
import { Button } from '@daedalus/atlas/Button';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { RoomWithoutOffers } from '@daedalus/core/src/room/types/room';
import { Chevron } from '../../../Chevron';
interface Props {
  bundleId: string;
  sbCheckoutUrl: string;
  rooms: RoomWithoutOffers[];
  cug: string[];
  providerCode: string;
  providerRateType: string;
}
const _exp = /*#__PURE__*/() => Button;
const StyledButton = /*#__PURE__*/styled(_exp())({
  name: "StyledButton",
  class: "s1ro7x5a",
  propsAsIs: true
});
export const OfferCTA = ({
  bundleId,
  sbCheckoutUrl,
  rooms,
  cug,
  providerCode,
  providerRateType
}: Props) => {
  const {
    handleClick
  } = useSplitBookingRoomOfferInteraction({
    bundleId,
    sbCheckoutUrl,
    rooms,
    cug,
    providerCode,
    providerRateType
  });
  return <StyledButton onClick={handleClick} variant="primary" iconEnd={<Chevron />} fullWidth>
      <FormattedMessageWrapper id="book" defaultMessage="Book" />
    </StyledButton>;
};

require("./OfferCTA.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./OfferCTA.tsx");